<template>
  <v-container fluid>
    <v-card flat>
      <v-container>
        <div class="hpanel">
          <div class="panel-heading" v-if="route === 'NewFacility'">
            <h4 class="earth-color">ADD NEW ACCOMMODATION OR CAMPING</h4>
          </div>
          <div class="panel-heading" v-else>
            <h4 class="earth-color">UPDATE ACCOMMODATION OR CAMPING</h4>
          </div>
          <hr />
          <v-form @submit.prevent="postInventory()">
            <v-layout row wrap>
              <v-flex lg4 md3 sm12 xs12>
                <v-container>
                  <v-text-field label="Income Account Code"
                                v-model="facility.code"
                                :rules="requiredRules"
                                required></v-text-field>
                </v-container>
              </v-flex>
              <v-flex lg4 md3 sm12 xs12>
                <v-container>
                  <v-text-field label="Department Analysis Code"
                                v-model="facility.analysis_code"
                                :rules="requiredRules"
                                required></v-text-field>
                </v-container>
              </v-flex>
              <v-flex lg4 md3 sm12 xs12>
                <v-container>
                  <v-text-field label="Outlet Analysis Code"
                                v-model="facility.outlet_analysis_code"
                                :rules="requiredRules"
                                required></v-text-field>
                </v-container>
              </v-flex>
              <v-flex lg4 md3 sm12 xs12>
                <v-container>
                  <v-text-field label="Accommodation/Camping Name"
                                v-model="facility.name"
                                :rules="requiredRules"
                                required></v-text-field>
                </v-container>
              </v-flex>
              <v-flex lg4 md6 sm12 xs12>
                <v-container fluid>
                  <v-select label="Select Pricing Model Type"
                            v-model="facility.facility_type_id"
                            :items="allFacilityTypes"
                            :rules="[(v) => !!v || 'Pricing Model Type is required']"
                            required
                            item-text="name"
                            item-value="public_id"
                            :loading="$loadingTrue"></v-select>
                </v-container>
              </v-flex>
              <v-flex lg4 md6 sm12 xs12>
                <v-container>
                  <v-text-field label="Maximum Guests Per Room"
                                v-model="facility.maximum_guests"
                                :rules="requiredRules"
                                required
                                type="number"></v-text-field>
                </v-container>
              </v-flex>
              <v-layout row
                        wrap
                        v-if="facility.facility_type_id === 'Accomodation'">
                <v-flex lg4 md4 sm12 xs12>
                  <v-container fluid>
                    <v-select label="Select Facility Type"
                              v-model="facility.accomodation_type_id"
                              :items="accommodationTypes"
                              :rules="[(v) => !!v || 'Accommodation Type is required']"
                              required
                              item-text="public_id"
                              item-value="public_id"
                              :loading="$loadingTrue"></v-select>
                  </v-container>
                </v-flex>
                <v-flex lg4 md4 sm12 xs12>
                  <v-container>
                    <v-text-field label="Quantity(Rooms Available)"
                                  v-model="facility.quantity"
                                  :rules="requiredRules"
                                  required
                                  type="number"></v-text-field>
                  </v-container>
                </v-flex>
                <v-flex lg4 md4 sm12 xs12>
                  <v-container>
                    <v-text-field label="Google Analytics Code"
                                  v-model="facility.google_analytics_code"
                                  type="text"></v-text-field>
                  </v-container>
                </v-flex>
                <v-flex lg3 md3 sm12 xs12>
                  <v-container>
                    <v-switch label="VAT"
                              color="primary"
                              v-model="facility.vat"
                              required></v-switch>
                  </v-container>
                </v-flex>
                <v-flex lg3 md3 sm12 xs12>
                  <v-container>
                    <v-switch label="Catering Levy"
                              color="primary"
                              v-model="facility.catering_levy"
                              required></v-switch>
                  </v-container>
                </v-flex>
                <v-flex lg2 md2 sm12 xs12>
                  <v-container>
                    <v-switch label="Has Extras?"
                              color="primary"
                              v-model="facility.has_extras"
                              required></v-switch>
                  </v-container>
                </v-flex>
                <v-flex lg3 md3 sm12 xs12>
                  <v-container>
                    <v-switch label="Has Revenue Split?"
                              color="primary"
                              v-model="facility.has_revenue_split"
                              required></v-switch>
                  </v-container>
                </v-flex>
                <!-- <v-flex lg6 md6 sm12 xs12 v-if="facility.has_revenue_split">
                  <v-container>
                    <v-text-field
                      label="Number of Splits?"
                      v-model.lazy="facility.split_number"
                      type="number"
                    ></v-text-field>
                  </v-container>
                </v-flex>
                <v-flex
                  lg6
                  md6
                  sm12
                  xs12
                  v-if="facility.split_number > 0 && facility.has_revenue_split"
                >
                  <v-layout
                    row
                    wrap
                    v-for="(
                      facilityIncomeCode, key
                    ) in allFacilityIncomeAccounts"
                    :key="key"
                  >
                    <v-text-field
                      label="Income Account"
                      v-model="allFacilityIncomeAccounts[key].income_account"
                      type="text"
                    ></v-text-field>
                    <v-text-field
                      label="Income Account Percent"
                      v-model="
                        allFacilityIncomeAccounts[key].income_account_percent
                      "
                      type="number"
                    ></v-text-field>
                  </v-layout>
                </v-flex> -->
              </v-layout>

              <v-layout row
                        wrap
                        v-else-if="facility.facility_type_id === 'Camping Sites'">
                <v-flex lg4 md4 sm12 xs12>
                  <v-container>
                    <v-switch label="VAT"
                              color="primary"
                              v-model="facility.vat"
                              required></v-switch>
                  </v-container>
                </v-flex>
                <v-flex lg4 md4 sm12 xs12>
                  <v-container>
                    <v-switch label="Catering Levy"
                              color="primary"
                              v-model="facility.catering_levy"
                              required></v-switch>
                  </v-container>
                </v-flex>
                <v-flex lg4 md4 sm12 xs12>
                  <v-container>
                    <v-switch label="Has Extras?"
                              color="primary"
                              v-model="facility.has_extras"
                              required></v-switch>
                  </v-container>
                </v-flex>
                <v-flex lg4 md4 sm12 xs12>
                  <v-container>
                    <v-text-field label="Google Analytics Code"
                                  v-model="facility.google_analytics_code"
                                  type="text"></v-text-field>
                  </v-container>
                </v-flex>
              </v-layout>

              <v-layout row
                        wrap
                        v-else-if="
                  facility.facility_type_id === 'External Accommodation'
                ">
                <v-flex lg6 md6 sm12 xs12>
                  <v-container>
                    <v-text-field label="Quantity"
                                  v-model="facility.quantity"
                                  :rules="requiredRules"
                                  required
                                  type="number"></v-text-field>
                  </v-container>
                </v-flex>
                <v-flex lg6 md6 sm12 xs12>
                  <v-container>
                    <v-text-field label="Google Analytics Code"
                                  v-model="facility.google_analytics_code"
                                  type="text"></v-text-field>
                  </v-container>
                </v-flex>
                <v-flex lg4 md4 sm12 xs12>
                  <v-container>
                    <v-switch label="VAT"
                              color="primary"
                              v-model="facility.vat"
                              required></v-switch>
                  </v-container>
                </v-flex>
                <v-flex lg4 md4 sm12 xs12>
                  <v-container>
                    <v-switch label="Catering Levy"
                              color="primary"
                              v-model="facility.catering_levy"
                              required></v-switch>
                  </v-container>
                </v-flex>
                <v-flex lg4 md4 sm12 xs12>
                  <v-container>
                    <v-switch label="Has Extras?"
                              color="primary"
                              v-model="facility.has_extras"
                              required></v-switch>
                  </v-container>
                </v-flex>

                <v-layout row
                          wrap
                          v-for="(facilityParameter, key) in allFacilityAllocation"
                          :key="key">
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-radio-group v-model="facility.allocation_id">
                        <v-radio :label="`${facilityParameter.name}`"
                                 :value="facilityParameter.public_id"></v-radio>
                      </v-radio-group>
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-layout>
              <v-flex lg12 md12 sm12 xs12>
                <v-container fluid>
                  <label>Description</label>
                  <vue-editor v-model="facility.description"></vue-editor>
                </v-container>
              </v-flex>
              <v-flex lg12 md12 sm12 xs12>
                <v-container fluid>
                  <v-btn :depressed="true"
                         color="primary"
                         v-if="this.$route.name !== 'EditFacility'"
                         type="submit">Add to Facility and Accommodation</v-btn>
                  <v-btn :depressed="true"
                         block
                         color="warning"
                         v-if="this.$route.name === 'EditFacility'"
                         type="submit">Update</v-btn>
                </v-container>
              </v-flex>
            </v-layout>
          </v-form>
        </div>
        {{ updateFacility }}
        <!-- {{ revenueSplit }} -->
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
  import { VueEditor } from "vue2-editor";
  export default {
    data() {
      return {
        route: this.$route.name,
        requiredRules: [(v) => !!v || "This field is required"],
        facility: {
          name: "",
          facility_type_id: "",
          accomodation_type_id: "",
          code: "",
          quantity: "",
          analysis_code: "",
          description: "",
          maximum_guests: "",
          session_id: localStorage.getItem("lkjhgfdsa"),
          public_id: this.$route.params.facility_id,
          vat: "",
          catering_levy: "",
          has_extras: "",
          outlet_analysis_code: "",
          google_analytics_code: "",
          allocation_id: "",
          percentage_commission: "",
          commission_account_code: "",
          has_revenue_split: false,
          // split_number: 0,
          // revenue_split_percent: [],
        },
      };
    },
    created() {
      this.$store.dispatch("get_all_facility_allocations");
      this.$store.dispatch("get_all_facility_types");
      this.$store.dispatch("get_all_accommodation_types");
      if (this.$route.name === "EditFacility") {
        this.$store.dispatch("get_facility", this.$route.params.facility_id);
      }
    },
    components: {
      VueEditor,
    },
    methods: {
      postInventory: function () {
        if (this.$route.name !== "EditFacility") {
          // this.facility["revenue_split_percent"] = this.allFacilityIncomeAccounts;
          this.$store.dispatch("post_facility", this.facility);
        } else {
          this.$store.dispatch("update_facility", this.facility);
        }
      },
    },

  };
</script>

<style></style>
